
import { IFormSections } from "@/interfaces/iForm";
import { defineComponent } from "vue";

export default defineComponent({
  name: "designer-title",
  components: {},
  props: {
    formSection: {
      type: Object as () => IFormSections,
      required: true,
    },
  },
  setup() {
    const controls = [];
    return {
      controls,
    };
  },
});
